// API & Services
import { VehicleServicesRow } from "services/api/calculations/vehicleservice/types";

// UI Components
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const CALCULATION_VEHICLE_SERVICES_SEARCH_COLUMNS: Column[] = [
  {
    title: "",
    field: "image",
    type: ColumnTypes.custom,
    render: (row: VehicleServicesRow) => {
      return (
        <div>
          <div className="w-10 h-10 rounded-full bg-gray-200 block relative">
            <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              {row.name.toString().charAt(0).toUpperCase()}
            </span>
          </div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.vehicleservices.search.name",
    field: "name",
    type: ColumnTypes.string,
  },
  {
    title: "admin.calculation.vehicleservices.search.price",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.ratePerKm} €</div>
        </div>
      );
    },
  },
];
